import ZkTable from './src/table'

/* istanbul ignore next */
ZkTable.install = function(Vue) {
  Vue.component(ZkTable.name, ZkTable)
}

export default ZkTable



// WEBPACK FOOTER //
// ./src/packages/table/index.js